import React from "react";
const metadata = [{
  label: "Pihak Terkait",
  value: "Kementerian Komunikasi dan Informatika"
}, {
  label: "Penulis/Editor",
  value: "Tim Redaksi Portal"
}, {
  label: "Tanggal Penerbitan",
  value: "24 Oktober 2023"
}, {
  label: "Status Verifikasi",
  value: "Terverifikasi Resmi"
}];
export default function MetaInformasiLengkap() {
  return <section id="meta-informasi-lengkap" className="w-full bg-background py-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-y border-border lg:border-x bg-card">
          {metadata.map((item, i) => <div key={i} data-index={i} className="flex flex-col justify-center p-5 lg:p-8 border-b sm:border-r lg:border-b-0 lg:border-r border-border last:border-b-0 sm:even:border-r-0 lg:even:border-r lg:last:border-r-0">
              <span className="mb-1 block font-sans text-[14px] uppercase tracking-wider text-secondary">
                {item.label}
              </span>
              <span className="block font-sans text-[18px] font-bold text-foreground">
                {item.value}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}